import { Button, DeleteIcon, GridColumn, GridRow, Input, Select, SelectOptionType } from '@bp/ui-components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { SingleValue } from 'react-select';
import { LessonFormType } from '../../types';

type LessonRoomSupplyFormItemProps = {
  index: number;
  current: SelectOptionType;
  options: SelectOptionType[];
  usedRoomUuids: string[];
  disabled: boolean;
  onDelete: () => void;
};

export const LessonRoomSupplyFormItem = ({
  index,
  current,
  options,
  disabled,
  usedRoomUuids,
  onDelete,
}: LessonRoomSupplyFormItemProps) => {
  const { t } = useTranslation();

  const { values, handleChange, setFieldTouched, setFieldValue } = useFormikContext<LessonFormType>();

  return (
    <GridRow spacingBottom='m' spacingTop='none'>
      <GridColumn width={10}>
        <GridRow spacingBottom='none' spacingTop='none'>
          <GridColumn width={6}>
            <Select
              isSearchable
              readonly={disabled}
              label={t('rooms.title', { count: 1 })}
              options={options.filter((r) => !usedRoomUuids?.includes(r.value as string))}
              name={`roomSupply.${index}.uuid`}
              value={current}
              onChange={async (option) => {
                const opt = option as SingleValue<SelectOptionType>;
                await setFieldTouched(`roomSupply.${index}.uuid`, true);
                await setFieldValue(`roomSupply.${index}.uuid`, opt?.value);
              }}
              menuPosition='fixed'
            />
          </GridColumn>
          <GridColumn width={6}>
            <Input
              readonly={disabled}
              label={t('rooms.addition')}
              name={`roomSupply.${index}.description`}
              onChange={handleChange}
              value={values.roomSupply ? (values.roomSupply[index].description ?? undefined) : undefined}
            />
          </GridColumn>
        </GridRow>
      </GridColumn>
      <GridColumn width={2} className='mt-5' align='end'>
        <Button hierarchy='tertiary' disabled={disabled} onClick={onDelete} icon={<DeleteIcon />} />
      </GridColumn>
    </GridRow>
  );
};
